<template>
 
 <div id="file-drag-drop">
    <form ref="fileform" :class="{small_form : smallForm}">
        <div class="drop-files ">

            <q-icon name="fas fa-cloud-upload-alt"  size='35px' class='q-ma-lg'/> 
            Перетащите файлы сюда!
            <p><strong>Внимание! Размер файла-превью (jpg) не должен быть больше 2 мб.</strong></p>
        </div>

    </form>
    <div class="file-container">
        <!-- <transition-group name="bounce" enter-active-class="animated tada" leave-active-class="animated bounceOutRight"> -->
            <loaded-file 
                    v-for ="(file_param) in files"
                    :key="file_param.id"
                    :fieldData = 'file_param'>
            </loaded-file>
        <!-- </transition-group> -->
    </div>
  </div>

</template>


<script>
/* eslint-disable */
import loadedFile from './uploadFile';

export default {
    name : 'upload',
    
    components : {
        loadedFile,
    },
    

    data(){
        return {
            dragAndDropCapable: false,

            file_id : 0, //идентификатор файла

            fileToLoad : [],

        }
    },

    computed : {
        
        files() {
            return this.fileToLoad;
        },

        smallForm() {
            return this.$store.getters.getPreviewFiles.length>0;
        }

    },
    methods :{

        getInitFileParams() {
            this.file_id ++;
            var q = {
                        file : null,
                        id :  this.file_id,
                        width : null,
                        height : null,
                        comment : "",
                        fileData : null,
            }
            return q;
        },

        determineDragAndDropCapable(){ // проверка на возможность применения drag&drop

            var div = document.createElement('div');

                    return ( ( 'draggable' in div )
                            || ( 'ondragstart' in div && 'ondrop' in div ) )
                            && 'FormData' in window
                            && 'FileReader' in window;
        },


        deleteUploadFile(id) {
            //удаляем из местного массива этот элемент
            const index = this.files.findIndex(item => item.id === id)
            this.files.splice(index, 1);

            // удаляем из базы
            this.$store.commit('deleteUploadFile', id);
        },

        clearAll() {
            this.files.splice(0, this.files.length); // удаляем местный массив
            this.$store.commit('clearAllUploadFile'); //удаляем из базы
        },
   
    }, //end methods

    mounted() {

        eventBus.$on("deleteUploadFile", this.deleteUploadFile);
        eventBus.$on('clearPreview', this.clearAll);
        
        var self = this;

        this.dragAndDropCapable = this.determineDragAndDropCapable(); // определеяем доступность драг-анд-дроп в браузере

        if (this.dragAndDropCapable) {
            ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
          
                this.$refs.fileform.addEventListener(evt, function(e){  //убираем стандартные обработчики 
                            e.preventDefault();
                            e.stopPropagation();
                     }.bind(this), false);
                     }.bind(this));

            this.$refs.fileform.addEventListener('drop', function(e){  //слушаем событие драг&дроп формы
                for( let i = 0; i < e.dataTransfer.files.length; i++ ){     // сохраняем список файлов себе в массив
                    
                    if (e.dataTransfer.files[i].size>2300000) {
                        this.$admns.showNotify('Файл-превью "'+e.dataTransfer.files[i].name+'" больше 2 мб. ','error','сообщение системы');
                        return;
                    }

                    var newFile = { file : e.dataTransfer.files[i], loaded : false, id : self.file_id };


                    var fileParam = self.getInitFileParams();
                    fileParam.file = newFile;

                    let parts = newFile.file.name.split('.');
                    let ext = parts[parts.length-1];

                    this.$store.commit('addNewUploadFile', e.dataTransfer.files[i]);

                    if (ext=='jpg') {
                        self.fileToLoad.push(newFile);
                        self.$store.commit('addPreviewFile', newFile);
                    }

                }
                
                window.scrollTo(0,0); // скроллим вверх

            }.bind(this));
        }

    },  //end mounted

    
}
</script>

<style lang="scss" scoped>

  form{
    display: block;
    height: 400px;
    width: 90%;
    background: #ccc;
    margin: auto;
    margin-top: 50px;
    text-align: center;
    line-height: 400px;
    border-radius: 4px;
    color : darkgray;


    &:hover {
        color : black;
    }

  }

  .small_form {
      height : 150px;
      line-height: 150px;  
  }
  .file-container {
        display: block;
        width: 90%;
        margin: auto;
        margin-top: 25px;
        text-align: center;
        margin-bottom: 25px;
  }


</style>


